<template>
    <v-container class="main-container">
        <div id="redirect-info"></div>
    </v-container>
</template>

<script>
import settings from "../settings";
import { mapState } from "vuex";

export default {
    name: "bulk-payment-view",
    data() {
        return {
            resources_url: settings.resources_url,
            api_url: settings.api_url,
            code: null,
            error: null
        };
    },
    async mounted() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        this.code = this.$route.params.paymentId;
        if (params.get("payment-key")) {
            this.code = params.get("payment-key");
        }
        let locale = window.app.pageData.locale ? window.app.pageData.locale : "et_EE";
        if (params.get("locale")) {
            locale = params.get("locale");
        }
        setTimeout(() => {
            window.TarkPay.initialize({
                container_id: "redirect-info",
                bulk_payment: true,
                client_id: window.app.pageData.client_id,
                locale: locale,
                is_modal: false,
                payment_id: this.code,
            });
        }, 1000);
    },
    computed: {
        ...mapState(["payment", "has_success"])
    },
    methods: {}
};
</script>

<style scoped>
.asc-banks-list img {
    width: 120px;
    height: 30px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}

@keyframes type {
    from {
        box-shadow: inset -3px 0px 0px #888;
    }
    to {
        box-shadow: inset -3px 0px 0px transparent;
    }
}
</style>
<style>
#redirect-main-container a div {
    display: flex;
}

#redirect-main-container a img {
    width: 150px;
    height: 50px;
    box-shadow: none;
}

#redirect-main-container .asc-banks-list {
    margin: 0px !important;
}

#redirect-main-container a.bank-link-EEUHEE2X div {
    background-color: #60cd18;
}

@media only screen and (max-width: 500px) {
    .main-container {
        padding: 0 !important;
    }
}
</style>
